import { useMemo } from 'react';

import { AccordionContainer, Grid, Typography } from '@frontierag/frontier-ui-library';
import useDataFieldHelpers from 'hooks/useDataFieldHelpers';

import type { IDataAccordionColumns } from './types';

export default function DataAccordionColumns({
  fieldsSchema,
  data,
  displayColumns = 2,
  title,
  subHeader,
  defaultExpanded = true,
  name,
  children,
}: IDataAccordionColumns) {
  const { renderValue, renderLabel, isHidden } = useDataFieldHelpers(data);

  const filteredColumnsData = useMemo(
    () =>
      fieldsSchema.map(({ fields, ...accordionProps }) => {
        const columns = [...fields].filter((field) => !isHidden(field));

        return { columns, ...accordionProps };
      }),
    [fieldsSchema, isHidden],
  );

  return (
    <AccordionContainer
      title={title}
      defaultExpanded={defaultExpanded}
      name={name}
      sx={{ '.MuiAccordionSummary-expandIconWrapper': { color: 'grey.main' } }}
    >
      {subHeader}

      <Grid direction="row" container spacing={{ xs: 2, sm: 3 }} alignItems="flex-start">
        {filteredColumnsData.map(({ columns }, index) => (
          <Grid
            direction="row"
            xs={12}
            sm={12 / displayColumns}
            container
            item
            spacing={2}
            key={`column-${index}`}
          >
            {columns.map((field, fieldIndex) => (
              <Grid
                item
                xs={12}
                key={`field-${field.accessor}-${fieldIndex}`}
                data-testid={`field-${field.accessor}`}
                sx={{ wordWrap: 'break-word' }}
              >
                <Typography variant="label1">{renderLabel(field)}:</Typography>
                <Typography variant="body2">{renderValue(field)}</Typography>
              </Grid>
            ))}
          </Grid>
        ))}
        {children}
      </Grid>
    </AccordionContainer>
  );
}
